@if (!faxService.hasAnyFaxNumbers() && !faxService.getAllNumbersInProgress) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <mat-card appearance="outlined" style="margin-top: 30px">
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <p-message severity="warn">
              <div>
                <p>
                  You must assign your user to a fax number in order to view and send faxes.
                  @if (hasPhoneNumbersEditRight) {
                    <span> Go to your <a class="btn-link" routerLink="/phone-numbers/list">Phone Numbers</a>  to customize settings.</span>
                  } @else {
                    <span> Contact your company administrator to setup messaging number.</span>
                  }
                </p>
                <p>
                  If you don not have eFax service enabled for your company, contact your <a class="btn-link"
                                                                                             role="button"
                                                                                             (click)="openSupportWidget()">Customer
                  Success Manager</a> to learn more about our eFax service.
                </p>
              </div>
            </p-message>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}
<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px"
     [style.visibility]="faxService.hasAnyFaxNumbers() && !faxService.getAllNumbersInProgress ? 'visible' : 'hidden'">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   (selectedItemsChanged)="onSelectedItemsChanged($event)"
                   [selectedItemsChange]="selectedFilterChange"
                   [showFilterButton]="true" (onFilterButtonClicked)="showFilterDialog()"
                   [showDateRange]="true" [defaultDateRange]="6"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
      @if (hasEditAccess) {
        <button mat-raised-button color="primary" class="send-fax-button" matTooltip="Send New Fax"
                (click)="openSendFaxView()">
          <mat-icon>print</mat-icon>
          Send Fax
        </button>
      }
    </app-filter-row-additional-content>
  </app-grid-filter>
  <div fxFlex class="stretched-container">
    <app-fax-grid [filterChangeEvent]="filterChangeEvent"
                  [hasContactsEditRight]="hasContactsEditRight"
                  [hasContactsModule]="hasContactsModule"
                  [userRights]="userRights"
    ></app-fax-grid>
  </div>
</div>
